import { gql } from "@apollo/client";

export const DATA_BROKER_FIELDS = gql`
  fragment DataBrokerFields on DataBroker {
    id
    name
    slug
    service
    createdAt
    updatedAt
    archivedAt
    settings {
      gcsBucket
      gcsBucketPrefix
      dataset
      location
    }
  }
`;

export const LIST_DATA_BROKERS = gql`
  ${DATA_BROKER_FIELDS}
  query ListDataBrokers {
    listDataBrokers {
      ...DataBrokerFields
    }
  }
`;

export const UPSERT_DATA_BROKER = gql`
  ${DATA_BROKER_FIELDS}
  mutation UpsertDataBroker($input: UpsertDataBrokerInput!) {
    upsertDataBroker(input: $input) {
      ...DataBrokerFields
    }
  }
`;

export const ARCHIVE_DATA_BROKERS = gql`
  mutation ArchiveDataBrokers($input: ArchiveDataBrokersInput!) {
    archiveDataBrokers(input: $input)
  }
`;

export const UNARCHIVE_DATA_BROKERS = gql`
  mutation UnarchiveDataBrokers($input: UnarchiveDataBrokersInput!) {
    unarchiveDataBrokers(input: $input)
  }
`;

export const GET_DATA_BROKER_OPT_IN_STATE = gql`
  query GetDataBrokerOptInState($input: DataBrokerOptInStateInput!) {
    dataBrokerOptInState(input: $input) {
      brokerName
      optedInSubaccountIds
    }
  }
`;

export const SET_DATA_TO_WIN_SUBACCOUNT_OPT_INS = gql`
  mutation SetDataToWinSubaccountOptIns(
    $input: SetDataToWinSubaccountOptInsInput!
  ) {
    setDataToWinSubaccountOptIns(input: $input)
  }
`;
